module.exports = __webpack_public_path__ + "img/logo4.7a8580ee.jpg";